import apiMagnoliaService from '~/services/bff/api.magnolia.service';
import apiProductsService from '~/services/bff/api.products.service';
import apiCategoriesService from '~/services/bff/api.categories.service';
import apiCartsService from '~/services/bff/api.carts.service';
import apiCheckoutService from '~/services/bff/api.checkout.service';
import apiFeatureFlagsService from '~/services/bff/api.featureFlags.service';
import apiContactsService from '~/services/bff/api.contacts.service';
import apiCustomersService from '~/services/bff/api.customers.service';
import apiMeService from '~/services/bff/api.me.service';
import apiShippingMethodsService from '~/services/bff/api.shippingMethods.service';
import apiOrdersService from '~/services/bff/api.orders.service';
import apiNewsletterService from '~/services/bff/api.newsletter.service';
import apiRecommendService from '~/services/bff/api.recommend.service';
import apiSearchService from '~/services/bff/api.search.service';
import apiDeliveryTimeService from '~/services/bff/api.deliveryTime.service';
import apiGeoapifyService from '~/services/bff/api.geoapify.service';

export const useBFF = () => {
  const { $bffApiFetch } = useNuxtApp();

  return {
    $carts: apiCartsService($bffApiFetch),
    $categories: apiCategoriesService($bffApiFetch),
    $checkout: apiCheckoutService($bffApiFetch),
    $contacts: apiContactsService($bffApiFetch),
    $customers: apiCustomersService($bffApiFetch),
    $featureFlags: apiFeatureFlagsService($bffApiFetch),
    $deliveryTime: apiDeliveryTimeService($bffApiFetch),
    $me: apiMeService($bffApiFetch),
    $products: apiProductsService($bffApiFetch),
    $shippingMethods: apiShippingMethodsService($bffApiFetch),
    $magnolia: apiMagnoliaService($bffApiFetch),
    $orders: apiOrdersService($bffApiFetch),
    $newsletter: apiNewsletterService($bffApiFetch),
    $recommend: apiRecommendService($bffApiFetch),
    $search: apiSearchService($bffApiFetch),
    $geoapify: apiGeoapifyService($bffApiFetch),
  };
};
